
/**
 * Gera um texto chamativo para ser usado nas redes sociais.
 * Garante o limite de 280 caracteres (Twitter).
 */
export function buildShareText({
  text,
  url,
  hashtag,
}: { text: string; url: string; hashtag?: string }): string {
  let msg = text.trim();
  // Limita o texto (deixa espaço para o link e hashtag)
  const hashtagText = hashtag ? ` #${hashtag.replace('#', '')}` : '';
  // Link ocupa ~23 caracteres (shortened pelo Twitter)
  const linkLength = 23;
  const base = `${msg}${hashtagText} ${url}`;
  let finalText = base;
  if (base.length > 280) {
    // Trunca o texto se passar o limite
    const allowedLen = 280 - linkLength - hashtagText.length - 2;
    msg = msg.slice(0, allowedLen) + '…';
    finalText = `${msg}${hashtagText} ${url}`;
  }
  return finalText;
}

/**
 * Função genérica para compartilhar via Web Share API ou fallback para links sociais.
 */
export async function sharePost({
  text,
  imageUrl,
  url,
  hashtag,
}: { text: string; imageUrl: string; url: string; hashtag?: string }) {
  const shareText = buildShareText({ text, url, hashtag });
  // Tenta o compartilhamento nativo (quando disponível)
  if (navigator.share) {
    const shareData: any = {
      text: shareText,
      url,
      title: text,
    };
    if (imageUrl && navigator.canShare && navigator.canShare({ files: [] })) {
      shareData.files = [imageUrl];
    }
    try {
      await navigator.share(shareData);
      return true;
    } catch (e) {
      // Usuário cancelou ou não suportado
      return false;
    }
  }
  return false;
}
